<template>
  <div id="services" class="page black">
      <div class="inner">

          <div class="services">
              <div class="service recording">
                  <div class="front">
                      Recording
                  </div>
                  <div class="back">
                      <!-- Whether you want to record a full band live, overdub to a click or just record the drums for your home production. -->
                  </div>
                </div>
                   <div class="service mixing">
                      <div class="front">
                        Mixing
                      </div>
                      <div class="back">
                      </div>
                  </div>
                   <div class="service mastering">
                      <div class="front">
                        Mastering
                      </div>
                      <div class="back">
                      </div>
                  </div>
                <div class="service preproduction">
                      <div class="front ">
                          Pre-Production
                      </div>
                      <div class="back">
                          
                      </div>
                  </div>
                
                  <div class="service demo">
                      <div class="front">
                        Demos
                      </div>
                      <div class="back">
                      </div>
                  </div>
                   <div class="service musicvid">
                      <div class="front">
                        Music Videos
                      </div>
                      <div class="back">
                      </div>
                  </div>
                  <div class="service vid">
                      <div class="front">
                        Sound to Motion Picture
                      </div>
                      <div class="back">
                      </div>
                  </div>  
                   <div class="service livesound">
                      <div class="front">
                        Live Sound
                      </div>
                      <div class="back">
                      </div>
                  </div>
                  <div class="service spoken">
                      <div class="front">
                        Spoken Word
                      </div>
                      <div class="back">
                      </div>
                  </div>
              </div>
          </div>

  </div>
</template>

<script>
export default {
  name: "intro"
};
</script>

<style scoped lang="scss">
#services{
  padding:0;
  margin:0;
  min-height:0;
}
.services {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-rows: calc(25vh - 25px);
  .service {
    padding:1em;
    border: 1px solid #333;
    background-color: black;
    color: white;

    .front{
      font-size:x-large;
      font-weight: bold;
    }
    .back{
      display:none;
    }
  }
  .musicvid{
    background-image: url("../assets/blured/musicvid_sm.jpg");
    background-size: cover;
    background-position: center;
    // &:hover{
    //   background-image: url("../assets/musicvid_sm.jpg");
    // }
  }
  .livesound{
    background-image: url("../assets/blured/livesound.jpg");
    background-size: cover;
    background-position: center;
    // &:hover, &:active{
    //   background-image: url("../assets/livesound.jpg");
    // }
  }
    .demo{
    background-image: url("../assets/blured/studiob.jpg");
    background-size: cover;
    background-position: center;
    // &:hover{
    //   background-image: url("../assets/studiob.jpg");
    // }
  }
  .preproduction{
    background-image: url("../assets/blured/preproduction.jpg");
    background-size: cover;
    background-position: center;
    // color:black;
    // &:hover{
    //   background-image: url("../assets/preproduction.jpg");
    // }
  }
  .recording{
    background-image: url("../assets/blured/drumkit.jpg");
    background-size: cover;
    background-position: center;
    // &:hover{
    //   background-image: url("../assets/drumkit.jpg");
    // }

  }
  .mastering{
    background-image: url("../assets/blured/mastering.jpg");
    background-size: cover;
    background-position: center;
    // &:hover{
    //   background-image: url("../assets/mastering.jpg");
    // }
    
  }
  .mixing{
    background-image: url("../assets/blured/mixing.png");
    background-size: cover;
    background-position: center;
    // &:hover{
    //   background-image: url("../assets/mixing.png");
    // }
    
  }
  .spoken{
    background-image: url("../assets/blured/spoken.jpg");
    background-size: cover;
    background-position: center;
    // &:hover{
    //   background-image: url("../assets/mixing.png");
    // }
    
  }
    .vid{
    background-image: url("../assets/blured/film.jpg");
    background-size: cover;
    background-position: center;
  
    
  }
  @media only screen and (max-width: 600px) {
     grid-template-columns: 1fr 1fr;
  }
}
</style>
